import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, BackdropCircular} from 'components';
import {
  Card,
  Typography,
  Divider,
  Grid,
  Switch,
  TextField,
  Button
} from '@material-ui/core';
import {
  getHomepageInstagramBlockConfigsApi,
  saveHomepageInstagramBlockConfigsApi
} from 'api';
import {
  changeHomepageInstagramBlockConfig
} from 'redux/actions/store_configs';


const InstagramBlock = () => {
  const dispatch = useDispatch();
  const urlRegExp =  /^https?:\/\/(.*)/;
  const {
    homepageInstagramBlockConfigs = [],
    loadingHomepageInstagramBlockConfigs,
    savingHomepageInstagramBlockConfigs
  } = useSelector((state) => state.store_configs);
  const loading = loadingHomepageInstagramBlockConfigs || savingHomepageInstagramBlockConfigs;
  const storeType = useSelector((state) => state.user?.profile?.stores?.[0])?.storeType || null;
  const isPremiumPlus = storeType === 'premium_plus';

  const [errorMessageLink, setErrorMessageLink] = useState('');
  const [errors, setErrors] = useState([]);


  useEffect(() => {
    getHomepageInstagramBlockConfigsApi({dispatch});
  }, []);

  const configValue = (path) => {
    return !homepageInstagramBlockConfigs.length
      ? ''
      : homepageInstagramBlockConfigs.find((config) => config.path === path).value;
  };

  const isBlockEnabled = configValue('store_info/instagram/is_instagram_block_enabled');
  const isButtonDisabled = isPremiumPlus ?
    isBlockEnabled == 1 && homepageInstagramBlockConfigs.some((element) => !element.value)
    :
    isBlockEnabled == 1 && configValue('store_info/instagram/instagram_block_script') === '';

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeHomepageInstagramBlockConfig(name, checked, type, value));
  };

  const handleBlure = (event) => {
    const {name, value} = event.target;

    if (!value && (isBlockEnabled == 1)) {
      setErrors((errors) => [...errors, name]);
    } else {
      setErrors((errors) => errors.filter((error) => error != name));
    }
  };

  const handleSave = () => {
    saveHomepageInstagramBlockConfigsApi({dispatch, configs: homepageInstagramBlockConfigs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'UI Configurations', path: '/settings#UI_configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: 'Instagram Widget'}
        ]}
      />
      <div className="m-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-8">Instagram Widget</Typography>
          <Divider className="mb-8" />
          <Grid container spacing={3} className="mb-8">
            <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
            <Grid item xs={12} sm={9}>
              <Switch
                color="primary"
                name={'store_info/instagram/is_instagram_block_enabled'}
                checked={isBlockEnabled == 1}
                onChange={handleChange}
              />
            </Grid>
            {isPremiumPlus &&
              <>
                <Grid item xs={12} sm={2} className="ml-4">Title</Grid>
                <Grid item xs={12} sm={9}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name={'store_info/instagram/instagram_block_name'}
                    label="Title"
                    value={configValue('store_info/instagram/instagram_block_name')}
                    onChange={handleChange}
                    onBlur={handleBlure}
                    error={errors.includes('store_info/instagram/instagram_block_name')}
                    helperText={errors.includes('store_info/instagram/instagram_block_name') && 'Field is required'}
                  />
                </Grid>
              </>
            }
            <Grid item xs={12} sm={2} className="ml-4">Script</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                required
                fullWidth
                multiline
                rows={7}
                variant="outlined"
                name={'store_info/instagram/instagram_block_script'}
                label="Script"
                value={configValue('store_info/instagram/instagram_block_script')}
                onChange={handleChange}
                onBlur={handleBlure}
                error={errors.includes('store_info/instagram/instagram_block_script')}
                helperText={errors.includes('store_info/instagram/instagram_block_script') && 'Field is required'}
                inputProps={{
                  className: 'p-0',
                  shrink: true
                }}
              />
            </Grid>
            {isPremiumPlus &&
              <>
                <Grid item xs={12} sm={2} className="ml-4">Button Text</Grid>
                <Grid item xs={12} sm={9}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name={'store_info/instagram/instagram_block_button_title'}
                    label="Button Text"
                    value={configValue('store_info/instagram/instagram_block_button_title')}
                    onChange={handleChange}
                    onBlur={handleBlure}
                    error={errors.includes('store_info/instagram/instagram_block_button_title')}
                    helperText={errors.includes('store_info/instagram/instagram_block_button_title') && 'Field is required'}
                  />
                </Grid>
              </>
            }
            {isPremiumPlus &&
              <>
                <Grid item xs={12} sm={2} className="ml-4">Button Link</Grid>
                <Grid item xs={12} sm={9}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name={'store_info/instagram/instagram_block_link'}
                    label="URL Address"
                    value={configValue('store_info/instagram/instagram_block_link')}
                    onChange={(event) => {
                      handleChange(event);
                      event.target.value.match(urlRegExp) ? setErrorMessageLink('') : setErrorMessageLink('Links must start with http://');
                    }}
                    onBlur={handleBlure}
                    error={Boolean(errorMessageLink)}
                    helperText={errorMessageLink}
                  />
                </Grid>
              </>
            }
          </Grid>
        </Card>
        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="my-10"
            onClick={handleSave}
            disabled={isButtonDisabled || Boolean(errorMessageLink)}
          >
            Save Configurations
          </Button>
        </div>
      </div>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default InstagramBlock;
